import * as React from 'react';

import _ from 'lodash';

import { Checkbox, ToolbarTable } from '@coursera/coursera-ui';

import ModalFooter from 'bundles/enterprise-admin-users/components/ModalFooter';
import { CHECKED_BACKGROUND_COLOR, TABLE_HEIGHT } from 'bundles/enterprise-admin-users/constants';
import type { Program } from 'bundles/enterprise-admin-users/types';

import _t from 'i18n!nls/enterprise-admin-users';

type Props = {
  handleClose: () => void;
  setProgram: (program: Program) => void;
  programs?: Program[];
  selectedProgram?: Program;
  onPreviousStep?: () => void;
  onContinue: () => void;
};

class ChooseProgramTable extends React.Component<Props> {
  onCheckboxClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    const programId = e.target.value;
    this.onProgramChange(programId);
  };

  onRowClick = (event: React.MouseEvent, row: { key: string }) => {
    const { key: programId } = row;
    this.onProgramChange(programId);
  };

  onProgramChange = (programId: string) => {
    const { setProgram, programs } = this.props;
    const selectedProgram = programs?.find((program) => program.id === programId);
    if (selectedProgram) {
      setProgram(selectedProgram);
    }
  };

  getRows = () => {
    const { programs, selectedProgram } = this.props;
    const selectedProgramId = selectedProgram && selectedProgram.id;
    return _.sortBy(programs, (program) => program.metadata.name).map((program) => ({
      key: program.id,
      name: program.metadata.name,
      isSelected: program.id === selectedProgramId,
      radio: (
        <Checkbox
          value={program.id}
          onChange={this.onCheckboxClick}
          checked={selectedProgramId === program.id}
          isRadio
          size={20}
          data-testid="program-option"
        />
      ),
    }));
  };

  getRowStyle = ({ isSelected }: { isSelected: boolean }) => {
    if (isSelected) return { backgroundColor: CHECKED_BACKGROUND_COLOR, cursor: 'pointer' };
    return { cursor: 'pointer' };
  };

  disableContinue = () => {
    const { selectedProgram } = this.props;
    return !selectedProgram;
  };

  render() {
    const { handleClose, onPreviousStep, onContinue } = this.props;
    return (
      <div className="rc-ChooseProgramTable">
        <h2 className="m-b-2">{_t('Choose program')}</h2>
        <p className="m-b-2">{_t('Choose the program you want to invite learners to')}</p>
        <ToolbarTable
          toolbar={[
            {
              type: 'search',
              placeholder: _t('Start typing the program name to filter the list'),
              accessor: 'name',
            },
          ]}
          columns={[
            {
              accessor: 'radio',
              width: '25px',
            },
            {
              accessor: 'name',
              header: _t('Name'),
              sortable: true,
            },
          ]}
          rows={this.getRows()}
          rowStyle={this.getRowStyle}
          height={TABLE_HEIGHT}
          onClick={this.onRowClick}
        />
        <ModalFooter
          onCancel={handleClose}
          onContinueLabel={_t('Continue')}
          onContinue={onContinue}
          onPrevious={onPreviousStep}
          disabled={this.disableContinue()}
        />
      </div>
    );
  }
}

export default ChooseProgramTable;
